






import { Component, Vue } from "vue-property-decorator";
import AuditLimbahTajamList from "@/components/ppi/audit-limbah-tajam/AuditLimbahTajamList.vue";

@Component({
  components: { AuditLimbahTajamList }
})
export default class AuditLimbahTajamPage extends Vue {}
